module.exports = __webpack_public_path__ + "app/kiss-seller/modal-sub-entity/modal-unupdated-pdp-subEntity-Arc5pS76.html";